import { memo } from 'react'

import { CompareItemsTable } from '../types'

import CompareItemsTableSpacerCell from './cells/SpacerCell'
import CompareItemsTableImageCell from './cells/ImageCell'
import CompareItemsTableAddItemImage from './cells/AddItemImage'
import CompareItemsTableItemCell from './cells/ItemCell'
import CompareItemsTableAddItem from './cells/AddItemCell'
import CompareItemsTableAttributeCell from './cells/AttributeCell'
import CompareItemsTableDataCell from './cells/DataCell'
import CompareItemsTableSplitSelectorCell from './cells/SplitSelectorCell'
import CompareItemsTableSplitHeaderCell from './cells/SplitHeaderCell'
import CompareItemsTableItemIndicatorCell from './cells/ItemIndicatorCell'

import style from './CompareItemsTableRow.module.scss'

export default memo(
  CompareItemsTableRow,
  (prevProps, nextProps) => prevProps.row === nextProps.row && prevProps.even === nextProps.even
)
export function CompareItemsTableRow({ row, even }: { row: CompareItemsTable['rows'][number]; even?: boolean }) {
  return (
    <div
      className={`${style.CompareItemsTableRow} ${row.seamless ? style['CompareItemsTableRow--seamless'] : ''} ${
        true === even ? style['CompareItemsTableRow--even'] : false === even ? style['CompareItemsTableRow--odd'] : ''
      }`}
    >
      {row.cells.map((cell, cellIndex) => {
        const cellClassName = `${style.CompareItemsTableRow__cell} ${
          cell.sticky ? style['CompareItemsTableRow__cell--sticky'] : ''
        }`
        switch (cell.type) {
          case 'spacer': {
            return (
              <CompareItemsTableSpacerCell className={cellClassName} cell={cell} width={cell.width} key={cell.key} />
            )
          }
          case 'image': {
            return (
              <CompareItemsTableImageCell className={cellClassName} cell={cell} width={cell.width} key={cell.key} />
            )
          }
          case 'add_item_image': {
            return (
              <CompareItemsTableAddItemImage className={cellClassName} cell={cell} width={cell.width} key={cell.key} />
            )
          }
          case 'item': {
            return <CompareItemsTableItemCell className={cellClassName} cell={cell} width={cell.width} key={cell.key} />
          }
          case 'add_item': {
            return <CompareItemsTableAddItem className={cellClassName} cell={cell} width={cell.width} key={cell.key} />
          }
          case 'split_selector': {
            return (
              <CompareItemsTableSplitSelectorCell
                className={cellClassName}
                cell={cell}
                width={cell.width}
                key={cell.key}
              />
            )
          }
          case 'split_header': {
            return (
              <CompareItemsTableSplitHeaderCell
                className={cellClassName}
                cell={cell}
                width={cell.width}
                key={cell.key}
              />
            )
          }
          case 'attribute': {
            return (
              <CompareItemsTableAttributeCell className={cellClassName} cell={cell} width={cell.width} key={cell.key} />
            )
          }
          case 'data': {
            return <CompareItemsTableDataCell className={cellClassName} cell={cell} width={cell.width} key={cell.key} />
          }
          case 'indicator': {
            return (
              <CompareItemsTableItemIndicatorCell
                className={cellClassName}
                cell={cell}
                width={cell.width}
                key={cell.key}
              />
            )
          }
          default: {
            return <div className={cellClassName} key={cellIndex} />
          }
        }
      })}
    </div>
  )
}
